module.exports = __webpack_public_path__ + "img/Slice2x.ff4b90cc.png";